import { forwardRef } from 'react';
import type { SelectHTMLAttributes } from 'react';
import { ChevronDown } from 'lucide-react';

import { cn } from '@/shared/lib/utils';

/**
 * `<select>` nativo, estilizado.
 *
 * Nativo de propósito: no celular ele abre a roda de seleção do sistema, que
 * um voluntário já sabe usar e que funciona com teclado, leitor de tela e
 * busca por digitação sem uma linha de JavaScript. Um combobox custom traria
 * dependência nova (regra 13) e uma pilha de estados para manter, para
 * ganhar... a seta.
 */
export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...props }, ref) => (
    <div className="relative">
      <select
        ref={ref}
        className={cn(
          // `bg-background` e não `bg-card`: sobre a área de conteúdo (branca),
          // campo preenchido é o que diferencia "aqui você digita" de texto —
          // e é o mesmo fundo do `Input` e do `Textarea`, que costumam estar
          // na mesma linha do formulário.
          'h-9 w-full appearance-none rounded-md border border-input bg-background py-1 pl-3 pr-8 text-sm',
          'transition-colors duration-fast ease-out hover:border-ring/40',
          'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden="true"
        className="pointer-events-none absolute right-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
      />
    </div>
  ),
);
Select.displayName = 'Select';
